module.exports = __webpack_public_path__ + "img/Best of Genf Rot.013a759d.jpg";